// Autogenerated by Hanako
import { Debug } from '../../views/ts/components/Debug';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Header } from '../../views/twig/components/Header';
import { Menu } from '../../views/twig/components/Menu';
import { Slider } from '../../views/twig/modules/slider';
(new Debug()).init();
(new LazyLoader()).init();
(new Header()).init();
(new Menu()).init();
(new Slider()).init();
